export default __webpack_public_path__ + "static/media/twitter.61143b07.svg";